import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10 card-bordered" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title fs-3 fw-bold" }
const _hoisted_4 = { class: "d-flex my-4" }
const _hoisted_5 = { class: "me-0" }
const _hoisted_6 = { class: "card-body pt-3 pb-10 px-2 px-md-8" }
const _hoisted_7 = { class: "flex items-center justify-center h-100%" }

import { handleError } from "@/core/helpers/errorHandler";
import FamiliasModule from "@/store/modules/FamiliasModule";
import moment from "moment";
import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { getModule } from "vuex-module-decorators";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const store = useStore();
const moduleFamilias = getModule(FamiliasModule, store);

const { t } = useI18n();
const isLoading = ref(false);
const error = ref();
error.value = null;

const fetch = async () => {
  try {
    isLoading.value = true;
    error.value = null;
    await moduleFamilias.fetchServicios();
  } catch (err) {
    error.value = err;
    handleError(err);
  } finally {
    isLoading.value = false;
  }
};

const formatDate = (date?: Date) => {
  return date ? moment(date).format("DD/MM/YYYY") : "";
};

const servicios = computed(() =>
  moduleFamilias.servicios.map((ele) => {
    return {
      ...ele,
      fechas: t("servicios.cabecera.fechasTpl", {
        inicio: formatDate(ele.inicioPrevisto),
        fin: formatDate(ele.finPrevisto),
      }),
      inscripcionString: formatDate(ele.inscripcion),
    };
  })
);

const onNuevoServicio = () => {
  router.push({ name: "servicios-colectivos" });
};

onMounted(() => fetch());

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("servicios.titulo")), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            type: "button",
            onClick: onNuevoServicio,
            class: "btn btn-primary"
          }, _toDisplayString(_ctx.$t("servicios.buttons.nuevo")), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        style: {"width":"100%"},
        stripe: "",
        data: _unref(servicios),
        "default-sort": { prop: 'menor', order: 'ascending' }
      }, {
        empty: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            (error.value)
              ? (_openBlock(), _createBlock(_component_el_empty, {
                  key: 0,
                  description: _ctx.$t('global.errores.carga')
                }, {
                  default: _withCtx(() => [
                    (error.value)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          size: "small",
                          onClick: fetch
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("global.acciones.reintentar")), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["description"]))
              : (_openBlock(), _createBlock(_component_el_empty, { key: 1 }))
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('servicios.cabecera.menor'),
            sortable: "",
            prop: "menor",
            "min-width": "180px"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('servicios.cabecera.servicio'),
            sortable: "",
            prop: "nombre",
            "min-width": "220px"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('servicios.cabecera.inscripcion'),
            sortable: "",
            prop: "inscripcionString",
            width: "150px"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('servicios.cabecera.fechas'),
            sortable: "",
            prop: "fechas",
            width: "220px"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('servicios.cabecera.estado'),
            sortable: "",
            width: "150px"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_tag, {
                class: "ml-2",
                type: 
                scope.row.estado == 'APROBADO'
                  ? 'success'
                  : scope.row.estado == 'RECHAZADO'
                  ? 'danger'
                  : ''
              
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(scope.row.estado), 1)
                ]),
                _: 2
              }, 1032, ["type"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, isLoading.value]
      ])
    ])
  ]))
}
}

})